import React from "react";
import {
  Edit,
  SimpleForm,
  ReferenceInput,
  AutocompleteInput,
  translate
} from "admin-on-rest";

const formStyle = {
  titleStyle: {
    textTransform: "capitalize"
  }
}

const DeviceTitleBase = ({record, translate}) => {
  return (
    <span style={formStyle.titleStyle}>
      {translate("resources.devices.titleEdit")} {record ? `${record.id}` : ""}
    </span>
  );
};

const DeviceTitle = translate(DeviceTitleBase);

class DeviceEditForm extends React.Component {
  render() {
    const props = {...this.props};
    return (      
      <Edit title={<DeviceTitle />} {...props}>        
        <SimpleForm>
          <ReferenceInput
            style={formStyle.tabStyle}
            label="resources.devices.inputs.storeName"
            source="kiosk_id"
            reference="kiosks"
            sort={{field: "name", order: "ASC"}}
            allowEmpty={false}
            filterToQuery={name => ({name_like: name})}
          >
            <AutocompleteInput optionText="name" />
          </ReferenceInput>
        </SimpleForm>
      </Edit>
    );
  }
}

export default DeviceEditForm;



// WEBPACK FOOTER //
// ./src/containers/CRM/Devices/DeviceEditForm.js